import { useAction, useAtom } from "@reatom/npm-react";
import { Block } from "../../components/Block/Block";
import { Header } from "../../components/Header/Header";
import s from "./style.module.scss";
import { Garanty } from "../../components/Garanty/Garanty";
import { FlexWrapper } from "../../components/FlexWrapper/FlexWrapper";
import { useEffect } from "react";
import { Icon12User, Icon56MoneyTransferOutline } from "@vkontakte/icons";
import clsx from "clsx";
import { Skeleton } from "@vkontakte/vkui";
import { useNavigate, useParams } from "react-router";
import {
  currentOrderAtom,
  getCurrentOrderAction,
  isLoadingCurrentOrderAtom,
} from "@/core/reatom/state/orders/orders";
import { Description } from "@/components/Description/Description";
import { StatusButton } from "@/components/Card/StatusButton/StatusButton";
import { AdditionalOrderOptions } from "@/components/AdditionalOrderOptions/AdditionalOrderOptions";
import { OrderEpic } from "@/components/OrderEpic/OrderEpic";
import { OrderInfo } from "@/components/OrderInfo/OrderInfo";
import { OrderHistory } from "@/components/OrderHistory/OrderHistory";
import { toggleModal } from "@/core/reatom/state/modal/modal";
import { getFeedbackAction } from "@/core/reatom/state/feedback/feedback";
import {
  uploadSessionAtom,
  uploadFileToSessionAtom,
} from "@/core/reatom/state/upload/upload";
import { openLink } from "@telegram-apps/sdk-react";

export const CheckoutPage = () => {
  const { id } = useParams();
  const [currentOrder] = useAtom(currentOrderAtom);
  const [isLoadingCurrentOrder] = useAtom(isLoadingCurrentOrderAtom);
  const handleFetchOrder = useAction(getCurrentOrderAction);
  const handleToggleModal = useAction(toggleModal);
  const handleFetchFeedback = useAction(getFeedbackAction);
  const [session, setSession] = useAtom(uploadSessionAtom);
  const [sessionFile, setSessionFile] = useAtom(uploadFileToSessionAtom);

  useEffect(() => {
    setSession(null);
    setSessionFile(null);
  }, []);
  useEffect(() => {
    if (!currentOrder?.id && id) {
      handleFetchFeedback(+id);
      if (currentOrder?.id !== +id && !isLoadingCurrentOrder) {
        handleFetchOrder({ orderId: +id });
      }
    }
  }, [currentOrder, isLoadingCurrentOrder]);
  const navigate = useNavigate();
  return (
    <div className={s.scrollWrapper}>
      <div className={s.innerWrapper}>
        <Header
          title={"Ваш заказ"}
          subTitle={
            isLoadingCurrentOrder ? "ТУ#" : currentOrder?.order_number ?? ""
          }
        />
        <FlexWrapper className={s.flexWrapper}>
          <Block borderRadius="bottom" className={s.header}>
            {!isLoadingCurrentOrder ? (
              <>
                {currentOrder?.process_status === "new" && (
                  <Icon56MoneyTransferOutline className={s.icon} />
                )}
                <OrderInfo />

                {currentOrder?.process_status === "new" &&
                  currentOrder.reserve?.status !== "reserved" && (
                    <p className={clsx(s.offerta, s.offertaDesktop)}>
                      Я принимаю условия{" "}
                      <span
                        onClick={() => {
                          openLink(
                            "https://st.fl.ru/about/documents/uslugi-freelancera/contract_fiz.pdf"
                          );
                        }}
                      >
                        Оферты на заключение Договора об использовании онлайн
                        сервиса «Защищенная Сделка в рамках сервиса Типовые
                        услуги»,
                      </span>{" "}
                      <span
                        onClick={() => {
                          openLink(
                            "https://st.fl.ru/about/documents/uslugi-freelancera/agreement_fiz.pdf"
                          );
                        }}
                      >
                        Оферты на заключение соглашения о выполнении работы
                        и/или оказании услуги,
                      </span>{" "}
                      <span
                        onClick={() => {
                          openLink("https://kassa.com/offers/fl");
                        }}
                      >
                        Публичной оферты об использовании Платежного сервиса
                        «Безопасный перевод»
                      </span>{" "}
                      и соглашаюсь на сотрудничество в их рамках.
                    </p>
                  )}
              </>
            ) : (
              <Skeleton className={s.card} height={150} />
            )}
          </Block>
          <Block borderRadius="bottom" className={s.cardBlock}>
            {currentOrder?.id && (
              <>
                <StatusButton
                  status={
                    currentOrder.reserve?.status === "reserved" &&
                    currentOrder.process_status === "new"
                      ? currentOrder.reserve.status
                      : currentOrder.process_status
                  }
                />
                <p className={s.title}>{currentOrder.title}</p>
                <div className={s.name}>
                  <Icon12User color="var(--icons-tertiary)" />
                  {currentOrder.freelancers[0].full_name}
                </div>
              </>
            )}

            <Description
              description={currentOrder?.description}
              isLoading={isLoadingCurrentOrder}
              //          result={currentService?.emp_result}
              requirements={currentOrder?.emp_requirement}
              date_post={currentOrder?.created_at}
              date_edit={currentOrder?.last_message_at}
            />
          </Block>
          {!isLoadingCurrentOrder && !!currentOrder?.extra.length && (
            <AdditionalOrderOptions extra={currentOrder?.extra} />
          )}

          <Block>
            <Garanty
              document
              days={currentOrder?.ends_in.duration}
              price={currentOrder?.reserve_price?.toLocaleString("ru-RU")}
              isLoadingAtom={isLoadingCurrentOrder}
              isLoadingSummaryAtom={false}
            />
          </Block>
          {!isLoadingCurrentOrder && <OrderHistory />}
        </FlexWrapper>
      </div>
      <OrderEpic />
    </div>
  );
};
